export default __webpack_public_path__ + "static/media/logo.aae6d1b5.svg";